import { takeLatest } from 'redux-saga/effects'
import { CREATE_GOOGLE_ANALYTICS_PROPERTY } from 'app/redux-base/actions/configurator'
import createGaProperty from './createGaProperty'

export default function* watchCreateGaProperty() {
  yield takeLatest(CREATE_GOOGLE_ANALYTICS_PROPERTY.REQUEST, createGaProperty)
}
